import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  set as setPermissionLevelForLayout
} from '../redux/layoutPermissions'
import { PermissionLevels } from 'utils/permission'

export default function * fetchPermissionLevelForLayout (action) {
  const { layoutId } = action.payload

  try {
    const { PermissionLevel } = yield call(apiGetData, 'PermissionForHomeLayout', {
      layoutId
    })

    yield put(setPermissionLevelForLayout({
      id: layoutId,
      permissionLevel: PermissionLevel
    }))
  } catch (error) {
    if (error.code === 601) {
      yield put(setPermissionLevelForLayout({
        id: layoutId,
        permissionLevel: PermissionLevels.NONE
      }))
    } else {
      throw error
    }
  }
}
